import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect } from 'react'
import Modal from 'react-modal';
import DocumentsService from '../../../services/DocumentsService';
import { API_URL } from '../../../appConfig';

const Doc: FC<any> = observer(({ doc }) => {

    return (
        <div className='row'>
            <hr />
            <div className="col">
                <a href={API_URL + doc['url']} className="doc-link" target="_blank" rel="noreferrer" download>
                    <div className="h6">{doc['name']}</div>
                    <div>
                        <span className="small me-1 text-primary"><Trans>Date</Trans>:</span>
                        <span className="small me-1">{doc['date']}</span>
                        <span className="small me-1 text-primary"><Trans>Chapter</Trans>:</span>
                        <span className="small me-1">{doc['chapter']['chapter']}</span>
                        <span className="small me-1 text-primary"><Trans>Publisher</Trans>:</span>
                        <span className="small me-1">{doc['publisher']['publisher']}</span>
                        <span className="small me-1 text-primary"><Trans>Status</Trans>:</span>
                        <span className="small me-1">{doc['status']['status']}</span>
                    </div>
                </a>
            </div>
        </div>

    )
});


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const MyDocsModal: FC<ModalProps> = observer(props => {
    const { toggle, setToggle } = props;
    const [documents, setDocuments] = useState([]);

    useEffect(() => {
        getDocs();
    }, []);

    const getDocs = async () => {
        const res = await DocumentsService.getMyDocs();
        setDocuments(res.data.results);
    }

    const getDocuments = () => documents.sort((a: any, b: any) => (b['id'] - a['id'])).map((doc: any, i: number) => {
        return <Doc key={i} {...{ doc }} />
    })

    const onRequestClose = () => {
        setToggle(false);
    };


    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} className='Small-Modal'>
            {/* <div className="row Small-Modal__Head d-flex">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
            </div> */}
            <form className="Small-Modal__Body">
                <div className="form-group mb-3">
                    {getDocuments()}
                </div>
            </form>
        </Modal >
    );
});